import { useCallback, useMemo, useState } from 'react';

import {
  GetNutritionPageQuery,
  GetStaticPageQuery,
  IGetStaticPageQuery,
  IGetStaticPageVariables,
  IStaticPage
} from 'remote/queries/static-page';
import { useLazySanityQuery } from 'state/graphql';

export const useStaticPage = () => {
  const [
    isNutritionExplorerMostRecentlyFetchedPage,
    setIsNutritionExplorerMostRecentlyFetchedPage
  ] = useState(false);

  const [
    getPage,
    {
      data: normalPageData,
      error: normalPageError,
      loading: normalPageLoading,
      refetch: normalPageRefetch
    }
  ] = useLazySanityQuery<IGetStaticPageQuery, IGetStaticPageVariables>(GetStaticPageQuery);

  const [
    getNutritionPage,
    {
      data: nutritionPageData,
      error: nutritionPageError,
      loading: nutritionPageLoading,
      refetch: nutritionPageRefetch
    }
  ] = useLazySanityQuery<IGetStaticPageQuery, IGetStaticPageVariables>(GetNutritionPageQuery);

  const retrieveStaticPageById = useCallback(
    (id: string, isNutritionPage = false): void => {
      setIsNutritionExplorerMostRecentlyFetchedPage(isNutritionPage);
      const pageGetter = isNutritionPage ? getNutritionPage : getPage;
      pageGetter({ variables: { id } });
    },
    [getNutritionPage, getPage]
  );

  const currentPage = useMemo<IStaticPage | undefined>(
    () =>
      isNutritionExplorerMostRecentlyFetchedPage
        ? nutritionPageData?.StaticPage
        : normalPageData?.StaticPage,
    [isNutritionExplorerMostRecentlyFetchedPage, nutritionPageData, normalPageData]
  );

  const error = isNutritionExplorerMostRecentlyFetchedPage ? nutritionPageError : normalPageError;
  const loading = isNutritionExplorerMostRecentlyFetchedPage
    ? nutritionPageLoading
    : normalPageLoading;
  const refetch = isNutritionExplorerMostRecentlyFetchedPage
    ? nutritionPageRefetch
    : normalPageRefetch;

  return { currentPage, error, loading, refetch, retrieveStaticPageById };
};
